export default "__VITE_ASSET__D79CV_p0__"